import store from '../store'
import firebase from '../libs/firebase'

export default {
  cleanUpView,
  cachePreRoute,
  requireAuth,
  requireUserInfo,
  restrictForUser,
  requireOfferings
}

function cleanUpView (to, from, next) {
  if (to.name === from.name) return next()

  window.scrollTo(0, 0)
  store.dispatch('close')
  store.dispatch('initViewState')
  store.dispatch('toolbar/setTitle', '')
  next()
}

function cachePreRoute (to, from) {
  store.dispatch('savePreRoute', from)
}

function requireAuth (to, from, next) {
  if (store.getters.isLoggedIn) {
    next()
  } else {
    next({ name: 'signin' })
  }
}

async function requireUserInfo (to, from, next) {
  const { isLoggedIn, isUserInfoExist, user } = store.getters

  if (isLoggedIn && isUserInfoExist) {
    next()
  } else if (!isLoggedIn && isUserInfoExist) {
    next({ name: 'signin' })
  } else if (isLoggedIn && !isUserInfoExist) {
    try {
      const db = firebase.client.database()
      await store.dispatch('initSettings', db.ref(`users/${user.uid}`))
      next()
    } catch (e) {
      next({ name: 'library' })
      throw e
    }
  } else {
    next({ name: 'signin' })
  }
}

function restrictForUser (to, from, next) {
  if (store.getters.isLoggedIn) {
    next({ name: 'library' })
  } else {
    next()
  }
}

async function requireOfferings (_1, _2, next) {
  await store.dispatch('purchases/getOfferings')
  next()
}
